import { forwardRef } from "react";
import { bool, node, string } from "prop-types";
import { closestCorners } from "@dnd-kit/collision";
import { useDroppable } from "@dnd-kit/react";
import { Grid } from "@material-ui/core";
import classnames from "classnames";

export const SortableContainer = forwardRef(({
  id,
  children,
  className,
  disabled,
  wrap="nowrap",
  alignItems="center",
  justifyContent="flex-start",
  ...containerProps
}, externalRef) => {
  
  const { ref } = useDroppable({
    id,
    disabled,
    collisionDetector: closestCorners,
  });
  
  const setRef = (el) => {
    ref(el);
    externalRef(el);
  }
  
  return <Grid
    ref={setRef}
    item container
    wrap={wrap}
    alignItems={alignItems}
    justifyContent={justifyContent}
    className={classnames("noDrag", className)}
    {...containerProps}
  >
    {children}
  </Grid>
})

SortableContainer.propTypes = {
  id: string.isRequired,
  children: node.isRequired,
  className: string,
  wrap: string,
  alignItems: string,
  justifyContent: string,
  disabled: bool,
}